/**
 * Variant Media By Alt – Custom logic (separate from theme's built-in variant/media logic).
 * Variant click: slider + thumbnails slide update based on variant title and image alt.
 * if no match, show all slides.
 * Uses Flickity remove/append so DOM state stays in sync with slider (no conflict).
 */
(function() {
    "use strict";

    let CACHE_KEY_SLIDES = "_variantAltAllSlides";
    let CACHE_KEY_THUMBS = "_variantAltAllThumbs";

    // Jab thumbnails view se kam: slider + har thumbnail ki position left se fix (Flickity 300%/400%/500% override)
    (function injectThumbLockStyles() {
        if (document.getElementById("variant-alt-thumb-lock-styles")) return;
        let style = document.createElement("style");
        style.id = "variant-alt-thumb-lock-styles";
        style.textContent = [
            ".variant-alt-thumbs-locked .flickity-slider{transform:translate3d(0px,0px,0px) !important;left:0 !important}",
            ".variant-alt-thumbs-locked .flickity-viewport{touch-action:pan-y}",
            ".variant-alt-thumbs-locked .flickity-slider>.f-product__media-thumbnails-item:nth-child(1){transform:translateX(0) !important}",
            ".variant-alt-thumbs-locked .flickity-slider>.f-product__media-thumbnails-item:nth-child(2){transform:translateX(100%) !important}",
            ".variant-alt-thumbs-locked .flickity-slider>.f-product__media-thumbnails-item:nth-child(3){transform:translateX(200%) !important}",
            ".variant-alt-thumbs-locked .flickity-slider>.f-product__media-thumbnails-item:nth-child(4){transform:translateX(300%) !important}",
            ".variant-alt-thumbs-locked .flickity-slider>.f-product__media-thumbnails-item:nth-child(5){transform:translateX(400%) !important}"
        ].join("");
        document.head.appendChild(style);
    })();

    function normalize(s) {
        let str = (s || "").toString().trim().toLowerCase();
        str = str.replace(/\s*\/\s*/g, "/");
        return str;
    }

    function altMatchesVariantName(alt, variantTitle) {
        if (!alt && !variantTitle) return false;
        let a = normalize(alt);
        let v = normalize(variantTitle);
        if (!a || !v) return false;
        return a === v || a.indexOf(v) !== -1 || v.indexOf(a) !== -1;
    }

    /** Returns indices of slides (from allSlides array) whose img alt matches variant title */
    function getMatchingIndicesFromSlides(allSlides, variantTitle) {
        let indices = [];
        for (let i = 0; i < allSlides.length; i++) {
            let img = allSlides[i].querySelector("img[alt]");
            if (img && altMatchesVariantName(img.getAttribute("alt"), variantTitle)) {
                indices.push(i);
            }
        }
        return indices;
    }

    function getFlickity(el) {
        if (!el || !window.FoxTheme || !window.FoxTheme.Flickity) return null;
        return window.FoxTheme.Flickity.data(el) || null;
    }

    /** Match theme media-gallery: no Flickity drag on video slides; 3D model drag is toggled via ModelViewerUI play/pause in product-media.js (loaded model alone must not lock the carousel). */
    function syncMainSliderDraggableForSelectedSlide(flkty, listEl) {
        if (!flkty || typeof flkty.option !== "function") return;
        let cellCount = flkty.cells ? flkty.cells.length : 0;
        if (cellCount < 2) {
            flkty.option("draggable", false);
            if (typeof flkty.updateDraggable === "function") {
                flkty.updateDraggable();
            }
            return;
        }
        let el =
            flkty.selectedElement ||
            (listEl && listEl.querySelector(".f-product__media.is-selected"));
        let type = el && el.dataset ? el.dataset.mediaType : "";
        let interactive =
            type === "video" ||
            type === "external_video";
        flkty.option("draggable", !interactive);
        if (typeof flkty.updateDraggable === "function") {
            flkty.updateDraggable();
        }
    }

    /** Ensure we have cached refs to all slides and thumbs (in document order). Call when gallery is full. */
    function ensureCache(mediaGallery) {
        if (mediaGallery[CACHE_KEY_SLIDES] && mediaGallery[CACHE_KEY_SLIDES].length > 0) {
            return true;
        }
        let slides = mediaGallery.querySelectorAll(".f-product__media");
        let thumbs = mediaGallery.querySelectorAll(".f-product__media-thumbnails-item");
        if (!slides.length) return false;
        mediaGallery[CACHE_KEY_SLIDES] = Array.prototype.slice.call(slides);
        mediaGallery[CACHE_KEY_THUMBS] = thumbs.length ? Array.prototype.slice.call(thumbs) : [];
        return true;
    }

    /**
     * Rebuild slider: remove all cells from Flickity, then append only the slides we want.
     * indicesToShow: array of indices into allSlides/allThumbs (e.g. [0, 2] or all indices for "show all").
     */
    function setSlidesByIndices(mediaGallery, indicesToShow) {
        let allSlides = mediaGallery[CACHE_KEY_SLIDES];
        let allThumbs = mediaGallery[CACHE_KEY_THUMBS];
        if (!allSlides || !allSlides.length) return;

        let listEl = mediaGallery.querySelector(".f-product__media-list") || mediaGallery.querySelector('[id^="Media-Gallery-"]');
        let thumbEl = mediaGallery.querySelector(".f-product__media-thumbnails") || mediaGallery.querySelector('[id^="GalleryThumbnails-"]');
        if (!listEl) return;

        let flkty = getFlickity(listEl);
        let thumbFlkty = thumbEl ? getFlickity(thumbEl) : null;

        if (!flkty || !flkty.cells) return;

        // Remove all current cells from main slider (use Flickity API so state stays correct)
        let cells = flkty.cells && flkty.cells.length ? flkty.cells.slice() : [];
        for (let c = 0; c < cells.length; c++) {
            flkty.remove(cells[c].element);
        }

        // Append only the slides we want, in order (data-media-index = position in filtered set for zoom/lightbox)
        for (let i = 0; i < indicesToShow.length; i++) {
            let idx = indicesToShow[i];
            let slide = allSlides[idx];
            if (slide) {
                slide.setAttribute("data-media-index", String(i));
                slide.setAttribute("data-index", String(i));
                let zoomBtn = slide.querySelector(".js-photoswipe--zoom");
                if (zoomBtn) zoomBtn.setAttribute("data-media-index", String(i));
                flkty.append(slide);
            }
        }

        let thumbsFitInView = indicesToShow.length <= 5;
        let thumbWrapper = mediaGallery.querySelector(".f-product__media-thumbnails-wrapper");

        if (thumbFlkty && allThumbs.length > 0) {
            let thumbCells = thumbFlkty.cells && thumbFlkty.cells.length ? thumbFlkty.cells.slice() : [];
            for (let tc = 0; tc < thumbCells.length; tc++) {
                thumbFlkty.remove(thumbCells[tc].element);
            }
            for (let t = 0; t < indicesToShow.length; t++) {
                let tidx = indicesToShow[t];
                let thumb = allThumbs[tidx];
                if (thumb) {
                    thumb.setAttribute("data-thumbnail-index", String(t));
                    thumb.setAttribute("data-index", String(t));
                    thumbFlkty.append(thumb);
                }
            }
            if (typeof thumbFlkty.reloadCells === "function") {
                thumbFlkty.reloadCells();
            }
            if (typeof thumbFlkty.option === "function") {
                thumbFlkty.option("wrapAround", indicesToShow.length > 5);
                thumbFlkty.option("draggable", !thumbsFitInView);
                thumbFlkty.option("freeScroll", !thumbsFitInView);
                thumbFlkty.option("cellAlign", thumbsFitInView ? "left" : "center");
            }
            thumbFlkty.select(0, false, true);
            if (typeof thumbFlkty.reposition === "function") {
                thumbFlkty.reposition();
            }
            if (listEl && typeof thumbFlkty.option === "function") {
                thumbFlkty.option("asNavFor", listEl);
            }
        }

        if (thumbsFitInView && thumbWrapper) {
            thumbWrapper.classList.add("variant-alt-thumbs-locked");
        } else if (thumbWrapper) {
            thumbWrapper.classList.remove("variant-alt-thumbs-locked");
        }

        if (typeof flkty.option === "function") {
            let canWrap = indicesToShow.length > 1;
            flkty.option("wrapAround", canWrap);
        }

        if (typeof flkty.reloadCells === "function") {
            flkty.reloadCells();
        }
        flkty.select(0, false, true);
        syncMainSliderDraggableForSelectedSlide(flkty, listEl);
        if (thumbFlkty && typeof thumbFlkty.select === "function") {
            thumbFlkty.select(0, false, true);
        }

        // Counter: current + total both variant/visible slides based on (1-based display)
        let totalCount = indicesToShow.length;
        let currentIndex = 0;

        function updateCounter() {
            let currentEl = listEl.querySelector(".flickity-counter--current") ||
                mediaGallery.querySelector(".flickity-counter--current");
            let totalEl = listEl.querySelector(".flickity-counter--total") ||
                mediaGallery.querySelector(".flickity-counter--total");
            if (currentEl) {
                currentEl.textContent = String(currentIndex + 1);
            }
            if (totalEl) {
                totalEl.textContent = String(totalCount);
            }
        }
        updateCounter();
        setTimeout(updateCounter, 50);

        // Jab user slide change kare toh current bhi update ho (Flickity change event)
        if (flkty._variantAltChangeHandler) {
            flkty.off("change", flkty._variantAltChangeHandler);
        }
        flkty._variantAltChangeHandler = function(index) {
            let curEl = listEl.querySelector(".flickity-counter--current") ||
                mediaGallery.querySelector(".flickity-counter--current");
            if (curEl) {
                curEl.textContent = String(index + 1);
            }
            syncMainSliderDraggableForSelectedSlide(flkty, listEl);
        };
        flkty.on("change", flkty._variantAltChangeHandler);

        // Zoom/lightbox: re-init so it uses same filtered slides (click main image = zoom shows only variant images)
        if (mediaGallery.enableZoom && mediaGallery.lightbox && typeof mediaGallery.lightbox.destroy === "function") {
            mediaGallery.lightbox.destroy();
        }
        if (mediaGallery.enableZoom && typeof mediaGallery.initImageZoom === "function") {
            mediaGallery.initImageZoom();
        }

        mediaGallery.dispatchEvent(
            new CustomEvent("gallery:rebuilt", { bubbles: false })
        );
    }

    function applyVariantFilter(mediaGallery, variant, retryCount) {
        if (!mediaGallery || !variant || !variant.title) return;

        retryCount = retryCount || 0;
        let maxRetries = 15;

        // First time: cache all slide/thumb elements (must be when gallery still has all items)
        if (!ensureCache(mediaGallery)) return;

        let allSlides = mediaGallery[CACHE_KEY_SLIDES];
        let variantTitle = variant.title;
        let matchingIndices = getMatchingIndicesFromSlides(allSlides, variantTitle);

        let indicesToShow;
        if (matchingIndices.length > 0) {
            indicesToShow = matchingIndices;
        } else {
            // No alt match: show all
            indicesToShow = [];
            for (let i = 0; i < allSlides.length; i++) {
                indicesToShow.push(i);
            }
        }

        let listEl = mediaGallery.querySelector(".f-product__media-list") || mediaGallery.querySelector('[id^="Media-Gallery-"]');
        let flkty = listEl ? getFlickity(listEl) : null;

        if (!flkty || !flkty.cells) {
            if (retryCount < maxRetries) {
                setTimeout(function() {
                    applyVariantFilter(mediaGallery, variant, retryCount + 1);
                }, 150);
            }
            return;
        }

        setSlidesByIndices(mediaGallery, indicesToShow);
    }

    function onVariantChanged(evt) {
        let variant = evt.detail && evt.detail.variant;
        let mediaGallery = document.querySelector("media-gallery");
        if (!mediaGallery) return;
        applyVariantFilter(mediaGallery, variant);
    }

    function onMediaLoaded(evt) {
        let variant = evt.detail && evt.detail.currentVariant;
        let mediaGallery = evt.target;
        if (!variant || !mediaGallery) return;
        // Cache when gallery has just loaded (all slides in DOM)
        ensureCache(mediaGallery);
        setTimeout(function() {
            applyVariantFilter(mediaGallery, variant);
        }, 250);
    }

    document.addEventListener("variant:changed", onVariantChanged);
    document.addEventListener("product-media:loaded", onMediaLoaded);
})();